import { WalletKit as Client } from "./client.js";

export * from "./constants/index.js";
export * from "./types/index.js";
export { isPaymentLink } from "./utils/index.js";

export const WalletKit = Client;
export default Client;
